<div class="text-white card alertsection alertsection-{{platform}}">
  <div class="p-5">
    <div class="d-flex align-items-center">
      <div id="carousel-announcement" class="carousel slide mx-4">
        <div class="carousel-inner">
          @for (item of announcements; track item.title; let isFirst = $first) {
            <div [class.active]="isFirst" class="carousel-item">
              <div class="d-block h-100 w-100">
                <h2>{{ item.title }}</h2>
                <div class="content-wrapper d-flex align-items-center">
                  <div class="announcement-content" [innerText]="item.message"></div>
                </div>
              </div>
            </div>
          }
        </div>

        @if (announcements.length > 1) {
          <a class="carousel-control-prev" data-bs-target="#carousel-announcement" role="button" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ 'previous' | translate }}</span>
          </a>
          <a class="carousel-control-next" data-bs-target="#carousel-announcement" role="button" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ 'next' | translate }}</span>
          </a>
        }

      </div>

    </div>
  </div>
</div>
